export enum HttpRequestType {
  DRM_LICENSE_WIDEVINE = 'DRM_LICENSE_WIDEVINE',
  DRM_OTHER = 'DRM_OTHER',
  MEDIA_THUMBNAILS = 'MEDIA_THUMBNAILS',
  MEDIA_VIDEO = 'MEDIA_VIDEO',
  MEDIA_AUDIO = 'MEDIA_AUDIO',
  MEDIA_PROGRESSIVE = 'MEDIA_PROGRESSIVE',
  MEDIA_SUBTITLES = 'MEDIA_SUBTITLES',
  MANIFEST_DASH = 'MANIFEST_DASH',
  MANIFEST_HLS = 'MANIFEST_HLS',
  MANIFEST_HLS_MASTER = 'MANIFEST_HLS_MASTER',
  MANIFEST_HLS_VARIANT = 'DRM_LICENSMANIFEST_HLS_VARIANTE_WIDEVINE',
  MANIFEST_SMOOTH = 'MANIFEST_SMOOTH',
  MANIFEST = 'MANIFEST',
  KEY_HLS_AES = 'KEY_HLS_AES',
  UNKNOWN = 'UNKNOWN',
  TIME_SYNC = 'TIME_SYNC',
  DRM_CERTIFICATE_FAIRPLAY = 'DRM_CERTIFICATE_FAIRPLAY',
  DRM_LICENSE_CLEARKEY = 'DRM_LICENSE_CLEARKEY',
  DRM_LICENSE_PRIMETIME = 'DRM_LICENSE_PRIMETIME',
  DRM_LICENSE_FAIRPLAY = 'DRM_LICENSE_FAIRPLAY',
  DRM_LICENSE_PLAYREADY = 'DRM_LICENSE_PLAYREADY',
  MANIFEST_ADS = 'MANIFEST_ADS',
}
